
export const backendURL = "https://mrstmrecords.onrender.com/api/v1";
export const socketURL = "http://localhost:5001/"

